import React from 'react';

import NoDebitCard from './NoDebitCard';
import DebitCardInfo from './DebitCardInfo';
import { AddDebitCardForm, EditDebitCardForm } from './Form';
import { initialDebitCard, transformCardForForm } from './utils';

const DebitCard = ({ card, formIsOn, formToggle, addDebitCard }) => (
  <div className="c-inner-wrapper u-max-width-710 u-mt-">
    <div
      className="c-inner-wrapper u-max-width-710 u-mt-"
      display-if={!card && !formIsOn}
    >
      <NoDebitCard onAdd={addDebitCard} />
    </div>
    <DebitCardInfo card={card} onEdit={formToggle} display-if={card && !formIsOn} />
    <AddDebitCardForm
      display-if={!card && formIsOn}
      cancel={formToggle}
      initialValues={initialDebitCard}
    />
    <EditDebitCardForm
      display-if={card && formIsOn}
      cancel={formToggle}
      initialValues={transformCardForForm(card)}
    />
  </div>
);

export default DebitCard;
